const _KEY = 'auth_info';

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export interface User {
  id: string;
  username: string;
  role: string;
  licensePackage?: 'Free' | 'Standard' | 'Trade' | 'Pro';
}

export interface InvestToken {
  token: string;
  tokenType: string;
  expiresIn: number;
}

export interface AuthInfo {
  token: string;
  forInvestToken: InvestToken;
  user: User;
  loginAt?: number; // unix ms timestamp of login
}

export function setAuth(authInfo: AuthInfo) {
  if (isBrowser()) {
    try {
      const serialized = JSON.stringify(authInfo);
      window.localStorage.setItem(_KEY, serialized);
    } catch (error) {
      console.error('Failed to save auth to localStorage:', error);
    }
  }
}

export function getAuth(): AuthInfo | null {
  if (isBrowser()) {
    try {
      const stored = window.localStorage.getItem(_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Failed to read auth from localStorage:', error);
      return null;
    }
  }
  return null;
}

export function clearAuth() {
  if (isBrowser()) {
    try {
      window.localStorage.removeItem(_KEY);
    } catch (error) {
      console.error('Failed to clear auth from localStorage:', error);
    }
  }
}
